module.exports = __webpack_public_path__ + "media/images/logo-df33c806e175fc3f8653aa5275c6d7a1.png";